
export const GameIds = {
  SMASH_ULTIMATE: "1386",
  MELEE: "1",
}

export const Characters = Object.freeze({
  "1386": {
    charList: ["banjokazooie","bayonetta","bowser","bowserjr","byleth","captainfalcon","chrom","cloud","corrin","diddykong","donkeykong","drmario","duckhunt","falco","fox","ganondorf","gnw","greninja","hero","iceclimbers","ike","incineroar","inkling","isabelle","jigglypuff","joker","kazuya","ken","kingdedede","kingkrool","kirby","link","littlemac","lucario","lucas","lucina","luigi","mario","marth","megaman","metaknight","mewtwo","miibrawler","miigunner","miiswordfighter","minmin","mythra","ness","olimar","pacman","palutena","peachdaisy","pichu","pikachu","piranhaplant","pitdarkpit","pokemontrainer","pyra","pyramythra","ridley","rob","robin","rosalinaandluma","roy","ryu","samusdarksamus","sephiroth","sheik","shulk","simonrichter","snake","sonic","sora","steve","terry","toonlink","villager","wario","wiifittrainer","wolf","yoshi","younglink","zelda","zss"]
  },
  "1": {
    charList: ["bowser","captainfalcon","donkeykong","drmario","falco","fox","ganondorf","iceclimbers","jigglypuff","kirby","link","luigi","mario","marth","mewtwo","mrgamewatch","ness","peach","pichu","pikachu","roy","samus","sheik","yoshi","younglink","zelda"]
  },
  "33945": {
    charList: ["aba","anji","asukar","axl","baiken","bedman","bridget","chipp","dizzy","elphelt","faust","giovanna","goldlewis","happychaos","ino","jacko","jam","johnny","ky","leo","lucy","may","millia","nagoriyuki","potemkin","ramlethal","sin","slayer","sol","testament","unika","venom","zato"]    
  },
  // "43868": {
  //   charList: ["aki","akuma","blanka","cammy","chunli","deejay","dhalsim","ehonda","ed","elena","guile","jp","jamie","juri","ken","kimberly","lily","luke","mbison","mai","manon","marisa","rashid","ryu","terry","zangief"]
  // },
  "49783": {
    charList: ["alisa","anna","armorking","asuka","azucena","bryan","claudio","clive","deviljin","dragunov","eddy","fahkumram","feng","heihachi","hwoarang","jack8","jin","jun","kazuya","king","kuma","kunimitsu","lars","law","lee","leo","leroy","lidia","lili","miaryzo","nina","panda","paul","raven","reina","shaheen","steve","victor","xiaoyu","yoshimitsu","zafina"]
    
  },
  "53945": {
    charList: ["absa","clairen","etalus","fleet","forsburn","galvan","kragg","lareina","loxodont","maypul","olympia","orcane","ranno","slade","wrastor","zetterburn"]    
  },
  "73221": {
    charList: ["andy","billy","bjenet","bluemary","chunli","cristiano","donghwan","gato","geese","hokutomaru","hotaru","jaehoon","joe","kain","ken","kevin","krauser","mai","marco","mrbig","preecha","rock","salvatore","terry","tizoc","vox"]
  }
});

export const ButtonCharacters = Object.freeze({
  "1386": ["mario", "ken", "pikachu", "ridley" ],
  "1": ["fox","falco","sheik","yoshi"],
  "33945": ["aba","anji","asukar","axl"],
  // "43868": ["luke","mai","ryu","rashid"],
  "49783": ["jin", "kazuya", "asuka", "reina"],
  "53945": ["kragg", "fleet", "maypul", "ranno"],
  "73221": ["andy", "billy", "mai", "kain"]
});

export const GameKeywords = Object.freeze({
  "1386": "Smash Ultimate, SSBU, competitive Smash, Smash tournaments, fighting game streams, Smash sets, tournament matches, esports, characters, gameplay, live matches",
  "1": "Smash Melee, Melee, competitive Melee, Melee tournaments, fighting game streams, Melee sets, tournament matches, esports, characters, gameplay, live matches",
  "33945": "Guilty Gear Strive, GGST, competitive Guilty Gear, Guilty Gear tournaments, fighting game streams, GGST sets, tournament matches, esports, characters, gameplay, live matches",
  "43868": "Street Fighter 6, SF6, competitive Street Fighter, SF6 tournaments, fighting game streams, SF6 sets, tournament matches, esports, characters, gameplay, live matches",
  "49783": "Tekken 8, T8, competitive Tekken, Tekken tournaments, fighting game streams, Tekken sets, tournament matches, esports, characters, gameplay, live matches",
  "53945": "Rivals of Aether 2, RoA2, competitive Rivals of Aether, Rivals tournaments, fighting game streams, RoA sets, tournament matches, esports, characters, gameplay, live matches",
  "48548": "Granblue Fantasy Versus, GBVS, competitive Granblue Fantasy, GBVS tournaments, fighting game streams, GBVS sets, tournament matches, esports, characters, gameplay, live matches",
  "73221": "Fatal Fury City of the Wolves, Fatal Fury, competitive Fatal Fury, Fatal Fury tournaments, fighting game streams, Fatal Fury sets, tournament matches, esports, characters, gameplay, live matches"
});

export const GamePublishers = Object.freeze({
  "1386": {
    "name": "Nintendo",
    "url": "https://www.nintendo.com/"
  },
  "53945": {
    "name": "Aether Studios",
    "url": "https://rivalsofaether.com/"
  },
  "43868": {
    "name": "Capcom",
    "url": "https://www.capcom.com/"
  },
  "1": {
    "name": "Nintendo",
    "url": "https://www.nintendo.com/"
  },
  "49783": {
    "name": "Bandai Namco Entertainment",
    "url": "https://www.bandainamcoent.com/"
  },
  "33945": {
    "name": "Arc System Works",
    "url": "https://www.arcsystemworks.jp/"
  },
  "48548": {
    "name": "Cygames",
    "url": "https://www.cygames.co.jp/"
  },
  "73221": {
    "name": "SNK",
    "url": "https://www.snk-corp.co.jp/"
  }
})



// 264x352
export const VideoGameInfo = Object.freeze([
  {
    "id": "1386",
    "name": "Super Smash Bros. Ultimate",
    "displayName": "Smash Ultimate",
    "gameSlug": "super-smash-bros-ultimate",
    // "displayName": "Ultimate",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/1386/image-d24f740623a31f9e1eec2aabc30f4ba2.jpg?ehk=Sn%2F72y2MSZz0neS6sqFNaHrl%2BK4pvHdLB7xd9CDX684%3D&ehkOptimized=Cv4voljXe9IIL1YmYNqg162zjL1hDYQvuyujRyflMX4%3D"
      },
      {
        "url": "https://images.start.gg/images/videogame/1386/image-df8b5408537089162788e68e026dee7b.png?ehk=KcISCzQslXsN9BRFd2lOX73XyWRcoKvUXSGlpkowu0Y%3D&ehkOptimized=bqVSF19aK4hKWmDEMRF1VwbkqBjFD%2FkAjY9I5SuPASE%3D"
      }
    ]
  },
  {
    "id": "53945",
    "name": "Rivals of Aether II",
    "displayName": "Rivals of Aether II",
    "gameSlug": "rivals-of-aether-ii",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/53945/image-51b85875cc3581106eb5986c02343438.png?ehk=9M208lBU1rR4A9Gxq2XobwvNaq5AwIio9exvntOrKOI%3D&ehkOptimized=TnKDP3iLZIJKAU4Zvf7CJ9yWRKM0F%2FbNtMtjVHAVfwY%3D"
      }
    ]
  },
  {
    "id": "43868",
    "name": "Street Fighter 6",
    "displayName": "Street Fighter 6",
    "gameSlug": "street-fighter-6",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/43868/image-e3e3c405db59bae213cb02dfee9ab9a0.jpg?ehk=ZtdBgarQyX4bTSuJWfPLdaFWXToJ3c2tx7DKUw7pN%2Fs%3D&ehkOptimized=jKLhJExgAx9csoAYGUD7hYyVdY1fPcbM1Cat8AekxtY%3D"
      },
      {
        "url": "https://images.start.gg/images/videogame/43868/image-983f6864d7ceec4eba46f2b1f2f96376.png?ehk=HbhnGpjHRr%2BzkoySljQC%2Bm4q8XWCUKVLfXmS8LlrxeU%3D&ehkOptimized=NyI804ksN7oS9PNRBRqfpr7bJ2%2FrjarPE4tZCMMPfjs%3D"
      }
    ]
  },
  {
    "id": "1",
    "name": "Super Smash Bros. Melee",
    "displayName": "Melee",
    "gameSlug": "super-smash-bros-melee",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/1/image-36450d5d1b6f2c693be2abfdbc159106.jpg?ehk=kHyxo9ZpitIjPcTdkRi6H4H8JkRXjeM5%2BousqjDV%2B%2FI%3D&ehkOptimized=CRpoBnGE8dtJkSIGcd2811UkurtlEPOKEay%2BqgCETlQ%3D"
      },
      {
        "url": "https://images.start.gg/images/videogame/1/image-5584f7c210c950a8b2bd65fbb6195f7a.png?ehk=zh8NxsAXJnb9bF8afAoE4%2Bw%2BFMB0jyoilZEtEKVXZwc%3D&ehkOptimized=fitamXYJEzDP2zNEjQkKW%2FYSWDlVsQ1OBEalHKu5CoE%3D"
      }
    ]
  },
  {
    "id": "49783",
    "name": "TEKKEN 8",
    "displayName": "TEKKEN 8",
    "gameSlug": "tekken-8",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/49783/image-acc13f09acce9819aa908ba77d621a05.jpg?ehk=jYogwhWRsoP38Mt7kbA5RLwuoFoH8y%2FBKabBOaDnmdg%3D&ehkOptimized=xnCM%2FeDWTNnEiVwwtXti50eZLgSc%2B6pb%2BTs2Do8O0Ks%3D"
      },
      {
        "url": "https://images.start.gg/images/videogame/49783/image-02076b03b40cbedcb96897a43670cfd5.jpg?ehk=bkXbFQDPPDs2aWLfmPbaXKggVvhnjobAF2bDh8%2FrRsI%3D&ehkOptimized=ImVCZu9KMU1cYTP8tG150ZAnXPSt2vLAIcu87A1GhRQ%3D"
      }
    ]
  },
  {
    "id": "33945",
    "name": "Guilty Gear: Strive",
    "displayName": "Guilty Gear: Strive",
    "gameSlug": "guilty-gear-strive",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/33945/image-baf58126feb19827670d6e88deac0d39.jpg?ehk=FXPTXzzOOO6%2BGgZFvIxiGkBMRyBPJlsWi3%2BSecHOOfU%3D&ehkOptimized=%2FSlM7PUdFRks7tJDVFTYaE1uV1MRIEI3Po0%2Br2geFZk%3D"
      },
      {
        "url": "https://images.start.gg/images/videogame/33945/image-100cf5f061503040429d489b79a3f54b.png?ehk=x4DN%2FdLv673ZPlSMFhS8cFNnIwPBHKjolT9S1TPJtu0%3D&ehkOptimized=YERewzBGH83HSe7aSCtYVZ6vqvyZyKFxh9xbdFY91uc%3D"
      }
    ]
  },
  {
    "id": "48548",
    "name": "Granblue Fantasy Versus: Rising",
    "displayName": "Granblue Fantasy Versus: Rising",
    "gameSlug": "granblue-fantasy-versus",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/48548/image-671eaa79165e3a80d6f89b2c9a09ccec.png?ehk=zAEyeT%2FAaIjXbqDLrJGHdHaPbEZDJtF6zgewmNx4c4M%3D&ehkOptimized=YWQ5ZkLjjw5VIxh98wlX%2Bo%2FwX6xRmQpglqMY5vEcG2Y%3D"
      }
    ]
  },
  {
    "id": "73221",
    "hide": "true",
    "name": "Fatal Fury: City of the Wolves",
    "displayName": "Fatal Fury: City of the Wolves",
    "gameSlug": "fatal-fury-city-of-the-wolves",
    "images": [
      {
        "url": "https://images.start.gg/images/videogame/73221/image-a8bb93cc531f7e62736f1b8c24f06f29.jpg?ehk=Uh0r5coU9wAG%2BTT4NPURV%2BvyDjoI7SXptv4%2Fph1l6cI%3D&ehkOptimized=lC2Q90lmxJje7Z5coBoi3wTMxM1FxNJrOfp5qThOpFs%3D"
      }
    ]
  }
]);

export const VideoGameInfoById = Object.fromEntries(
  VideoGameInfo.map(item => [item.id, item])
);

export const VideoGameInfoByGameSlug = Object.fromEntries(
  VideoGameInfo.map(item => [item.gameSlug, item])
);


const TimeRanges = Object.freeze({
  "1386": [-1.5, 0],
  "1": [-3.5, 0],
  // "33945": 
  // "43868": 
  //   charLis
  // "49783": 
  // "53945": 
});

export function getDefaultTimeRange(gameId) {
  const defaultRangeValue = [-6.5, 0]
  return TimeRanges[gameId] ?? defaultRangeValue
}

export function charactersAsSuggestionArr(gameId) {
  return Characters[gameId]?.charList?.map(charName => { return {charName}})
}